import React, { useEffect } from "react";
import styles from "./index.module.css";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectVehicleList } from "../../../redux/features/vehicle/vehicleSlice";
import { getVehicles } from "../../../redux/features/vehicle/vehicleService";
import SearchFilters from "../../../components/SearchFilters";
import { getAllMakes } from "../../../redux/features/make/makeService";
import { selectMakeList } from "../../../redux/features/make/makeSlice";
import { getModel } from "../../../redux/features/model/modelService";
import { selectModelList } from "../../../redux/features/model/modelSlice";
import { getModelCode } from "../../../redux/features/modelCode/modelCodeService";
import { selectModelCodeList } from "../../../redux/features/modelCode/modelCodeSlice";
import { getTransmission } from "../../../redux/features/transmission/transmissionService";
import { selectTransmissionList } from "../../../redux/features/transmission/transmissionSlice";
import { getFuel } from "../../../redux/features/fuel/fuelService";
import { selectFuelList } from "../../../redux/features/fuel/fuelSlice";
import { getVehicleType } from "../../../redux/features/vehicleType/vehicleTypeService";
import { selectVehicleTypeList } from "../../../redux/features/vehicleType/vehicleTypeSlice";
import { getCountry } from "../../../redux/features/country/countryService";
import { getColor } from "../../../redux/features/color/colorService";
import { selectCountryList } from "../../../redux/features/country/countrySlice";
import { selectColorList } from "../../../redux/features/color/colorSlice";
import VerticalSearchFilters from "../../../components/SearchFilters/VerticalSearchFilters";
import VehicleCardFull from "../../../components/Vehicles/VehicleCardFull";
import VehicleCardSkeleton from "../../../components/Vehicles/VehicleCardFull/VehicleCardSkeleton";

const noOfDoors = [];

for (let i = 1; i < 8; i++) {
  noOfDoors.push({ name: i });
}

const noOfSeats = [];

for (let i = 1; i < 60; i++) {
  noOfSeats.push({ name: i });
}

const interiorCond = [
  { id: 'A', name: 'A' },
  { id: 'B', name: 'B' },
  { id: 'C', name: 'C' },
  { id: 'D', name: 'D' },
];
const exteriorCond = [
  { id: 'R', name: 'R' },
  { id: '3.5', name: '3.5' },
  { id: '4', name: '4' },
  { id: '4.5', name: '4.5' },
  { id: '5', name: '5' },
  { id: 'S', name: 'S' },
];

const steering = [{ id: 'RHD', name: 'RHD' }, { id: 'LHD', name: 'LHD' }];

const wheelDrive = [{ id: '2WD', name: '2WD' }, { id: '4WD', name: '4WD' }];

const years = Array.from({ length: 45 }, (v, i) => {
  return { name: i + 1980 };
});

const prices = Array.from({ length: 60 }, (v, i) => {
  return { name: i * 50000 + 50000 };
});

const engineCC = Array.from({ length: 10 }, (v, i) => {
  return { name: i * 500 + 100 };
});

const mileage = Array.from({ length: 10 }, (v, i) => {
  return { name: i * 5000 + 5000 };
});

const Vehicles = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: vehicles, status } = useSelector(selectVehicleList) || {};

  const filters = Object.fromEntries([...searchParams.entries()]);

  const { status: listLoading, data: makes } = useSelector(selectMakeList);
  const { status: modelsLoading, data: models } = useSelector(selectModelList);
  const { status: modelCodeLoading, data: modelCode } = useSelector(selectModelCodeList);
  const { status: transmissionLoading, data: transmission } = useSelector(selectTransmissionList);
  const { status: fuelLoading, data: fuel } = useSelector(selectFuelList);
  const { status: vehicleTypeLoading, data: vehicleType } = useSelector(selectVehicleTypeList);
  const { status: countryLoading, data: country } = useSelector(selectCountryList);
  const { status: colorLoading, data: color } = useSelector(selectColorList);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getAllMakes({}));
    dispatch(getTransmission({}));
    dispatch(getFuel({}));
    dispatch(getVehicleType({}));
    dispatch(getCountry({}));
    dispatch(getColor({}));
  }, [dispatch]);

  const handleMakeSelect = (makeId) => {
    dispatch(getModel({ makeId: makeId }));
  };

  const handleModelSelect = (modelId) => {
    dispatch(getModelCode({ modelId: modelId }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getVehicles({ ...filters, status: true }));
  }, [searchParams, dispatch]);

  const removeFilter = (key) => {
    const params = new URLSearchParams(searchParams);
    params.delete(key);
    setSearchParams(params);
  };

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);

    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }

    setSearchParams(params);
  };

  return (
    <div className="main-container">
      <div className="container-content wrapped-content">
        <div className={styles.activeFilters}>
          {Object.entries(filters).map(([key, value]) => {
            if (!value) return null;

            return (
              <span key={key} className={styles.filterTag}>
                {value}
                <button
                  onClick={() => removeFilter(key)}
                  className={styles.removeBtn}
                >
                  ✕
                </button>
              </span>
            );
          })}
        </div>
        <div className={styles.bodyDiv}>
          <div className={styles.leftSearchOne}>
            <VerticalSearchFilters
              makes={makes}
              models={models}
              onMakeSelect={handleMakeSelect}
              modelCodes={modelCode}
              onModelSelect={handleModelSelect}
              prices={prices}
              years={years}
              transmissions={transmission}
              fuels={fuel}
              vehicleTypes={vehicleType}
              engineCC={engineCC}
              wheelDrives={wheelDrive}
              steerings={steering}
              mileages={mileage}
              countries={country}
              interiorColors={color}
              exteriorColors={color}
              // doors={noOfDoors}
              // seats={noOfSeats}
              interiorConditions={interiorCond}
              exteriorConditions={exteriorCond}
            />
          </div>
           <div className={styles.leftSearchTwo}>
            <SearchFilters
              makes={makes}
              models={models}
              onMakeSelect={handleMakeSelect}
              modelCodes={modelCode}
              onModelSelect={handleModelSelect}
              prices={prices}
              years={years}
              transmissions={transmission}
              fuels={fuel}
              vehicleTypes={vehicleType}
              engineCC={engineCC}
              wheelDrives={wheelDrive}
              steerings={steering}
              mileages={mileage}
              countries={country}
              interiorColors={color}
              exteriorColors={color}
              // doors={noOfDoors}
              // seats={noOfSeats}
              interiorConditions={interiorCond}
              exteriorConditions={exteriorCond}
            />
          </div>
          <div className={styles.rightVehicleGrid}>
             {status === 'loading'?
          Array.from(Array(12), (_, i) => {
            return (
              <div key={i}>
                <VehicleCardSkeleton />
              </div>
            );
          })
        :
        vehicles?.length != 0 ?
              vehicles.map((vehicle, i) => (
                <div key={i}>
                  <VehicleCardFull
                    id={vehicle.id}
                    name={vehicle.name}
                    imageUrl={vehicle.image_url}
                    price={vehicle.vehicle_costs[0]?.selling_price ? vehicle.vehicle_costs[0]?.selling_price : parseInt("Ask")}
                    wheelDrive={vehicle.wheel_drive}
                    engineCC={vehicle.engine_capacity}
                    year={vehicle.mfg_year}
                    mileage={vehicle.mileage}
                    fuelType={vehicle.fuel.name}
                    gearType={vehicle.transmission.name}
                    model={vehicle.model.name}
                    modelCode={vehicle.model_code?.name}
                    color={vehicle.exterior_color.name}
                    steering={vehicle.steering}
                    doors={vehicle.no_of_doors}
                    seats={vehicle.no_of_seats}
                    stockNo={vehicle.stock_no}
                    make={vehicle.make.name}
                    tag={
                      vehicle.isFeatured
                        ? "FEATURED"
                        : vehicle.isPopular
                          ? "POPULAR"
                          : ""
                    }
                  />
                </div>
              ))
            : 
            <p>No vehicles match your search</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vehicles;